// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","800":"boards"}[chunkId] + "." + {"594":"2305a9df","800":"7baf7320"}[chunkId] + ".js";
};